import moment from "moment";

export default {
    objectId: {
        set(newVal) {
            return {
                val: newVal,
                type: /^[0-9a-fA-F]{24}$/i.test((newVal || "").toString()) ? "objectId" : typeof newVal,
            };
        },
    },
    percent: {
        set(newVal) {
            return {
                val: newVal,
                type: newVal >= 0 && newVal <= 100 ? "percent" : typeof newVal,
            };
        },
    },
    currency: {
        set(newVal) {
            const parseVal = Number(newVal);
            return {
                val: parseVal,
                type: Number.isNaN(parseVal) ? typeof newVal : "currency",
            };
        },
    },
    lookup: {
        set(newVal) {
            return {
                val: newVal,
                type: "lookup",
            };
        },
    },
    utcDate: {
        set: function (newVal) {
            let newType;
            if (newVal === null) {
                newType = typeof null;
            } else if (!moment.isMoment(newVal)) {
                newType = "utcDate";
                newVal = moment.utc(newVal);
            } else {
                newType = "utcDate";
            }

            return {
                val: newVal,
                type: newType,
            };
        },
        get: function (val) {
            if (val === null) {
                return val;
            }
            return moment(val); // clone
        },
        default: function () {
            return moment.utc();
        },
        fastSet: false,
    },
};
